<ng-container *transloco="let t; read: 'moreDetails.roomCard'">
  <article class="room-more-details">
    <p [innerHTML]="room.discount" *ngIf="room.discount"></p>
    <p [innerHTML]="room.description" *ngIf="room.description"></p>
    <p [innerHTML]="room.roomDescription" *ngIf="room.roomDescription"></p>
    <p [innerHTML]="room.paymentInformation" *ngIf="room.paymentInformation"></p>
    <p [innerHTML]="room.roomFacilities" *ngIf="room.roomFacilities"></p>
    <p [innerHTML]="room.pleaseNote" *ngIf="room.pleaseNote"></p>
    <p class="card-text in-policy" *ngIf="room.inPolicy && (configFacade.hasPolicyEnabled$ | async)">
      {{ t('inPolicy') }}
    </p>
    <p [innerHTML]="room.taxStatement"></p>
    <p *ngIf="room.prePay">
      <span class="f-family-semibold">{{ t('prePayment') }}</span
      ><br /><span [innerHTML]="room.prePay"></span>
    </p>
    <p *ngIf="room.preAuth">
      <span class="f-family-semibold">{{ t('preAuth') }}</span
      ><br /><span [innerHTML]="room.preAuth"></span>
    </p>
    <p *ngIf="room.roomPolicy?.parkingPolicy">
      <span class="f-family-semibold">{{ t('parking') }}</span
      ><br /><span [innerHTML]="room.roomPolicy.parkingPolicy"></span>
    </p>
    <p *ngIf="room.roomPolicy?.internetPolicy">
      <span class="f-family-semibold">{{ t('internet') }}</span
      ><br /><span [innerHTML]="room.roomPolicy.internetPolicy"></span>
    </p>
    <p *ngIf="room.roomPolicy?.childrenPolicy">
      <span class="f-family-semibold">{{ t('children') }}</span
      ><br /><span [innerHTML]="room.roomPolicy.childrenPolicy"></span>
    </p>
  </article>
</ng-container>
